import {destroyAttachmentsMutation} from '../../components/Projects/mutations'
import {updateAttachemntsInStore} from '../uploadFiles'

export function onDestroySelect(selected) {
  const index = this.state.filesSelectedToRemove.indexOf(Number(selected))
  if (index < 0) {
    this.state.filesSelectedToRemove.push(Number(selected))
  } else {
    this.setState({filesSelectedToRemove: this.state.filesSelectedToRemove.splice(index, 1)})
  }
  this.setState({filesSelectedToRemove: this.state.filesSelectedToRemove})
}

export function destroyAttachments(apolloClient, filesToRemove, attachableId, attachableType, apolloTypeName) {
  if (filesToRemove.length === 0) return

  apolloClient.mutate({
    mutation: destroyAttachmentsMutation,
    variables: {
      attachment_id: filesToRemove,
      attachable_id: Number(attachableId),
      attachable_type: attachableType
    }
  }).then(({data}) => {
    if (data.destroyAttachments.response === 'ok') {
      updateAttachemntsInStore(apolloClient, attachableId, apolloTypeName, {removeAttachments: filesToRemove})
    }
  })
}



// WEBPACK FOOTER //
// ./src/utils/forms/removeFiles.js